// Dashboard main page
import {
  IonIcon,
  IonPage,
  IonTab,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import {
  bodyOutline,
  analyticsOutline,
  fitnessOutline,
  home,
} from "ionicons/icons";
import { OverallFitness } from "./components/OverallFitnessTab";
import { Trends } from "./components/TrendsTab";
import { AvatarTab } from "./components/AvatarTab";
import HomeTab from "./components/HomeTab";
import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router";
import { ClientDataHolder } from "./data/data";
import { useAuth } from "../../context/AuthContext";
import { AuthProvider } from "../utils/http-service";
import { ClientData, MeasureData, ObjectModelData, ShareLinkData } from "../utils/interfaces";
import { currentConfig } from "../../common/domainConfig";
import { ObjectModel } from "../../common/types";

const tabs = (
  client: ClientDataHolder,
  clientData: ClientData,
  measurementDatas: MeasureData[],
  models: ObjectModel[],
  shared?: ShareLinkData,

  first?: string,
    
) => {
  return [

    <IonTab key="home" tab="home" className="overflow-y-scroll">
      <div id="home-page">

        {client && (
          <HomeTab shared={shared} clientHolder={client} clientData={clientData} measurementDatas={measurementDatas} objectModels={models}></HomeTab>
        )}
      </div>
    </IonTab>,
    <IonTab key="avatar" tab="avatar" className="overflow-y-scroll">
      <div id="avatar-page">
{ models.length>0&& <AvatarTab clientHolder={client} clientData={clientData} measurementDatas={measurementDatas} objectModels={models}></AvatarTab>
}      </div>
    </IonTab>,
    <IonTab key="trends" tab="trends" className="overflow-y-scroll">
      <div id="trends">
        {client && (
          <Trends clientHolder={client} clientData={clientData} measurementDatas={measurementDatas} objectModels={models}></Trends>
        )}{" "}
      </div>
    </IonTab>,
    <IonTab key="overall" tab="overall" className="overflow-y-scroll">
      <div id="overall-page">
        {client && (
          <OverallFitness
            clientHolder={client}
            clientData={clientData}
            measurementDatas={measurementDatas} 
            objectModels={models}
          ></OverallFitness>
        )}
      </div>
    </IonTab>,
  ]
    .sort((a, b) => (a.props.tab == first ? -1 : 0))
    .filter((t) => currentConfig.dashboard.tabs.includes(t.props.tab));
};
const DashboardPage = () => {
  const { isAuthenticated, getAccessTokenSilently, isLoading } = useAuth();
  const [clientData, setClientData] = useState<ClientData>();
  const [shared, setShared] = useState<ShareLinkData>();
  const params = useParams<{ id: string }>();
  let searchParams = new URLSearchParams(useLocation().search);

  const clientId = params.id;
  const code = searchParams.get("code") || undefined;
  const cookieHint = searchParams.get("cookie") === '1';
  const auth = new AuthProvider(getAccessTokenSilently, code, clientId, undefined, cookieHint);
  const isAnonymous = auth.anonymous() || cookieHint;

  const showTab = searchParams.get("show") || (code &&  'avatar' ||'home'); ;
  const [measurementDatas, setMeasurementDatas] = useState<MeasureData[]>([]);
  const [models, setModels] = useState<ObjectModel[]>([]);
  const [client] = useState<ClientDataHolder>(
    new ClientDataHolder(clientId, auth, setClientData, setMeasurementDatas,setModels, setShared)
  );
  useEffect(() => {
    if (isAuthenticated) {
      client.load();
    } else if (!isLoading && !isAuthenticated && (code || cookieHint)) {
      // Share-link or cookie-based auth: skip Auth0 token, rely on sw_share cookie
      client.auth.isCookieSet = true;
      client.load();
    }
  }, [clientId, isAuthenticated, isLoading]);
  if (!clientData) {
    return (
      <IonPage>
        <IonTitle>Loading...</IonTitle>
      </IonPage>
    );
  }

  return (
    <IonPage className="mt-16">
      <IonTabs>
        {client && tabs(client, clientData,measurementDatas, models,shared, showTab )}

       {currentConfig.dashboard.tabs.length>1&& <IonTabBar slot="bottom">
          {[<IonTabButton key="home" tab="home">
            <IonIcon icon={home} />
            Home
          </IonTabButton>,
          <IonTabButton key="avatar" tab="avatar">
            <IonIcon icon={bodyOutline} />
            Avatar
          </IonTabButton>,
          <IonTabButton key="trends" tab="trends">
            <IonIcon icon={analyticsOutline} />
            Statistics
          </IonTabButton>,
          <IonTabButton key="overal" tab="overall">
            <IonIcon icon={fitnessOutline} />
            Target
          </IonTabButton>].filter((t) =>
            currentConfig.dashboard.tabs.includes(t.props.tab)
          ).filter((t) => !(isAnonymous && t.props.tab === 'home'))}
        </IonTabBar>}
      </IonTabs>
    </IonPage>
  );
};
export default DashboardPage;
